import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.file',
    modules: [
        R,
    ],
})
@Service('FileStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('files');
    }

    refresh () {
        let self = this;
        return self._refresh().then(function(data){
            self.list.push(...data);
            return self;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/file.js